import { addPresetOptions, processLayouts } from 'pro-gallery-lib';
export function processFlattenStyles(styles, fullscreenOverrides) {
  const options = processLayouts(addPresetOptions(styles), true);
  if (fullscreenOverrides) {
    const fullscreenMigratedOptions = {
      ...styles,
      ...fullscreenOverrides
    };
    return {
      options,
      fullscreenOptions: fullscreenMigratedOptions
    };
  }
  return {
    options,
    fullscreenOptions: undefined
  };
}
//# sourceMappingURL=options-proccesor.js.map